import { initReactI18next, I18nextProvider } from 'react-i18next'
import React from 'react'
import i18nFactory from '../i18n-api/i18n-factory'

/**
 * High order component which apply i18n provider configuration
 * @param {React Component} WrappedComponent - Component to be wrapped
 * @param {object} frontHubContext - An object containing the FrontHub context
 * @param {function} intlFormatting - Used to interpolate the intl configuration
 * @returns
 */
const withI18n = (WrappedComponent, frontHubContext, intlFormatting) => {
  const { configuration } = frontHubContext

  const i18n = i18nFactory({
    configuration,
    intlFormatting,
    plugins: [initReactI18next],
  })
  return props => (
    <I18nextProvider i18n={i18n}>
      <WrappedComponent {...props} />
    </I18nextProvider>
  )
}

export default withI18n
